import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Route } from 'vue-router'
import store from './store'

// import axios from 'axios'
import 'view-design/dist/styles/iview.css';
import ViewUI from 'view-design';
import Vuex from 'vuex'


Vue.use(Vuex)

import topTitle from "./components/topTitle"
Vue.component('topTitle', topTitle)
import footerCom from "@/components/footerCom"
Vue.component('footerCom', footerCom)


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import './util/common.css'

import 'jquery/dist/jquery.min'

/*import 'bootstrap/dist/css/bootstrap.css'*/

import util from '@/util/axios.js';

Vue.prototype.$util = util

import common from '@/util/common.js';

Vue.prototype.$common = common

Vue.prototype.$store = store
Vue.config.productionTip = false

import echarts from 'echarts'
Vue.prototype.$echarts = echarts


Vue.use(ViewUI);

Vue.use(ElementUI);

import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import "@/assets/fonts/style.css";
Vue.use(VueQuillEditor, /* { default global options } */)

Vue.prototype.$Message.config({
    top: document.documentElement.clientHeight / 2 - 100,
    duration: 3
});

import './util/dialog' // 引入可拖动的js

import { Message } from 'element-ui';
//定义一个新的Message方法，多传入一个offset参数
const $message = options => {
    return Message({
        ...options,
        offset: document.documentElement.clientHeight / 2 - 100
    });
};

//重写方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
    $message[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options,
                offset: 200
            };
        }
        options.type = type;
        return Message(options);
    };
});
//将$message挂载到this上
Vue.prototype.$message = $message;
//不加这行代码运行this.$message.closeAll时会报错
Vue.prototype.$message.closeAll = Message.closeAll;

Vue.directive('date-format', {
    inserted(el, binding) {
        const { value, arg = 'YYYY-MM-DD HH-mm-ss' } = binding;
        const dateObj = new Date(value);
        const formatMap = {
            YYYY: dateObj.getFullYear(),
            MM: String(dateObj.getMonth() + 1).padStart(2, '0'),
            DD: String(dateObj.getDate()).padStart(2, '0'),
            HH: String(dateObj.getHours()).padStart(2, '0'),
            mm: String(dateObj.getMinutes()).padStart(2, '0'),
            ss: String(dateObj.getSeconds()).padStart(2, '0')
        };
        el.textContent = arg.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => formatMap[match]);
    }
});

new Vue({
    router,
    store,
    Route,
    render: h => h(App),
    // beforeCreate() {
    //     Vue.prototype.$bus = this
    // },
    ...App
}).$mount('#app')